import styled from "styled-components";

export const ContentLoader = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  z-index: ${({ loaderHomeScreen }) => (loaderHomeScreen ? "99" : "")};
  position: ${({ loaderHomeScreen }) => (loaderHomeScreen ? "fixed" : "")};
`;
